export default __webpack_public_path__ + "static/03_Tiger-c8686b37563a3394209a179430f34207.png";